import http from "@/utils/http";

// 文本翻译
export function translateText(headers, data) {
  const config = {
    method: "POST",
    url: `/user/translate/text`,
    data,
    headers,
  };
  return http(config);
}

// 生成 vcf 文件
export function generateVcfFile(headers, data) {
  const config = {
    method: "POST",
    url: `/user/file/uploadCustom`,
    data,
    headers,
  };
  return http(config);
}

// 屏幕截图
export function getPosterImg(headers, data) {
  const config = {
    method: "POST",
    url: `/poster/tools/shot`,
    data,
    headers,
  };
  return http(config);
}

// 屏幕截图
export function getPosterImgToAi(headers, data) {
  const config = {
    method: "POST",
    url: `/user/tools/shotPro`,
    data,
    headers,
  };
  return http(config);
}

export function getQrCodeConfig(headers, sceneId) {
  const config = {
    method: "GET",
    url: `/user/qr/getQrCodeConfig/${sceneId}`,
    headers,
  };
  return http(config);
}


export function exAndForumStatistics(headers, data) {
  const config = {
    method: "POST",
    url: `/user/admin/event/report/meeting/exAndForum/statistics`,
    headers,
    data
  };
  return http(config);
}



export function exAndForumStatisticsExport(headers, params) {
  const config = {
    method: "get",
    url: `/user/admin/event/report/meeting/exAndForum/statistics/export`,
    params,
    headers,
  };
  return http(config);
}

